import React from "react";
import { observable, toJS } from "mobx";
import { isInvalidoCodigoContainer } from "../../../utils/validadores";

export default class CargaGeralImportarXLSStore {
  @observable listaNovas;
  @observable listaArquivos;

  @observable erroImportXLS;
  @observable xlsVazio;
  @observable validandoXLS;
  @observable salvando;

  @observable navioSelecionadoAgend;

  constructor(service) {
    this.listaNovas = [];
    this.listaArquivos = [];

    this.salvando = false;

    this.navioSelecionadoAgend = false;
    this.mensagemErroValidacao =
      "Falha ao carregar arquivo. Verifique o seu conteúdo e tente novamente.";

    this.service = service;
  }

  resetaErroXls = () => {
    this.erroImportXLS = false;
  };

  validarListaDadosUnicos(lista) {
    const unicos = new Set();

    for (let item of lista) {
      const identificador = `${item.Motorista}-${item.Placa}-${item.Cnh}-${item.Cpf}`;
      if (unicos.has(identificador)) {
        return false; // Encontrado um item duplicado
      }
      unicos.add(identificador);
    }

    return true; // Todos os itens são únicos
  }


   validarCnhComCPF(lista) {
    const cnhCpfMap = new Map();

    for (let item of lista) {
      if (cnhCpfMap.has(item.Cnh)) {
        if (cnhCpfMap.get(item.Cnh) !== item.Cpf) {
          return false; // Mesma CNH encontrada com CPF diferente
        }
      } else {
        cnhCpfMap.set(item.Cnh, item.Cpf);
      }
    }

    return true; // Não foram encontradas CNHs com CPFs diferentes
  }


  validarCpfComCNH(lista) {
    const cpfCnhMap = new Map();
  
    for (let item of lista) {
      if (cpfCnhMap.has(item.Cpf)) {
        if (cpfCnhMap.get(item.Cpf) !== item.Cnh) {
          return false; // Mesmo CPF encontrado com CNH diferente
        }
      } else {
        cpfCnhMap.set(item.Cpf, item.Cnh);
      }
    }
  
    return true; // Não foram encontrados CPFs com CNHs diferentes
  }
  

  guardaXLS = (event) => {
    this.salvando = true;
    this.resetaErroXls();
    this.erroImportXLS = false;
    this.xlsVazio = false;
    this.xlsFileData = event.target.files[0];
    let data = new FormData();
    data.append("file", this.xlsFileData);

    this.service
      .xlsImporta(data)
      .then((response) => {
        this.salvando = false;

        if (response.data.length > 0) {

          if (!this.validarListaDadosUnicos(response.data)) { 
            this.setErroImportXLS(); this.mensagemErroValidacao = "Encontrados dados duplicados"
            return;
        }

        if (!this.validarCnhComCPF(response.data)) {
          this.setErroImportXLS(); this.mensagemErroValidacao = "Há CPFs diferentes para mesma CNH" ;
          return;
        }

        if (!this.validarCpfComCNH(response.data)) {
          this.setErroImportXLS(); this.mensagemErroValidacao = "Há CNHs diferentes para o mesmo CPF" ;
          return;
        }
            
            response.data.map((d) => {
              if (this.validarXLS(d)) {
                this.listaNovas.push(d);
              } else {
                this.setErroImportXLS();
                return;
              }
            });

          if (!this.erroImportXLS){
            this.resetaErroXls();        
            this.listaArquivos.push({
              nomeArquivo: this.xlsFileData.name.replace(/[^a-zA-Z0-9\.]/g, ""),

            });

          } else {
            this.listaNovas = [];
          } 
        } else {
          this.xlsVazio = true;
        }
      })
      .catch((err) => {
        console.log(err);
        this.jsonFile = null;
        this.setErroImportXLS();
      })
      .finally(() => (this.validandoXLS = false));
  };

  setErroImportXLS = () => {
    this.erroImportXLS = true;
  };

  validarXLS = (d) => {
    if (
      !d.Cnh ||
      d.Cnh === "" ||
      d.Cnh.length < 11 ||
      d.Cnh.length > 11 ||
      (/[^\d]/).test(d.Cnh)
    ) {
      this.mensagemErroValidacao = `Verifique o formato do Cnh ${d.Cnh}`;
      return false;
    }
    if (
      !d.Cpf ||
      d.Cpf === "" ||
      d.Cpf.length < 11 ||
      d.Cpf.length > 11 ||
      (/[^\d]/).test(d.Cpf)
    ) {
      this.mensagemErroValidacao = `Verifique o formato do Cpf ${d.Cpf}`;
      return false;
    }
    if (
      !d.Placa ||
      d.Placa === "" ||
      d.Placa.length < 7 ||
      d.Placa.length > 7 ||
      !(/[A-Z]{3}[0-9][0-9A-Z][0-9]{2}/).test(d.Placa)
    ) {
      this.mensagemErroValidacao = `Verifique o formato da placa ${d.Placa}`
      return false;
    }
    if (!d.Motorista || d.Motorista === "" || !(/^[^\d]*$/).test(d.Motorista) || d.Motorista.toLowerCase().includes("exemplo")) {
      this.mensagemErroValidacao = `Verifique o nome do motorista na aba Dados ${d.Motorista}`
      return false;
    }


    return true;
  };

  setNavio = (event) => {
    if (event) this.navioSelecionadoAgend = event;
    else this.navioSelecionadoAgend = false;
  };
}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/stores/CargaGeralImportarXLSStore.js